import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { Planejamento } from '../classes/Planejamento'

@Injectable({
  providedIn: 'root',
})
export class PlanejamentoService {
  public planejamentoSelecionado: Planejamento

  constructor(private http: HttpClient) {}

  getPlanejamentos(): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento`)
  }

  getPlanejamentosPorSafra(safraId: number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/listarPorSafra/${safraId}`,
    )
  }
  listarPorAnoSafraCultura(
    anoSafraId: number,
    culturaId: number,
  ): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/listarPorAnoSafraCultura/${anoSafraId}/${culturaId}`,
    )
  }
  listarPorAnoSafraFazenda(anoSafraId: number, fazendaId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/listar/${anoSafraId}/${fazendaId}`);
  }
  getListarPlanosAgronomico(safraId: number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/listarPlanosAgronomico/${safraId}`,
    )
  }
  getPlanejamentosDetalhe(planejamentoId: number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/ListarPlanejamentosDetalhe/${planejamentoId}`,
    )
  }

  getPlanejamentosPorSafraArea(
    safraId: number,
    areaId: number,
  ): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/listarPorSafraArea/${safraId}/${areaId}`,
    )
  }
  getPlanejamentosPorSafras(safras: number[]): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/planejamento/listarPorSafra`,
      safras,
    )
  }

  getPlanosMestrePorCultura(culturaId: number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/listarPlanoMestre/${culturaId}`,
    )
  }

  listarPlanosMestrePorCultura(culturaId: number): Observable<any>{
    return this.http.get(`${environment.apiURL}/planejamento/listarPlanoMestrePorCultura/${culturaId}`)
  }

  getPlanejamento(id: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/${id}`)
  }

  postPlanejamento(planejamento: Planejamento): Observable<any> {
    return this.http.post(`${environment.apiURL}/planejamento`, planejamento)
  }

  putPlanejamento(id: number, planejamento: Planejamento): Observable<any> {
    return this.http.put(
      `${environment.apiURL}/planejamento/${id}`,
      planejamento,
    )
  }

  deletePlanejamento(id: number): Observable<any> {
    return this.http.delete(`${environment.apiURL}/planejamento/${id}`)
  }

  deleteListaPlanejamento(ids: number[]): Observable<any> {
    var params = new HttpParams()
    ids.forEach((id) => {
      params = params.append('ids', id.toString())
    })

    return this.http.delete(`${environment.apiURL}/planejamento/`, {params})
  }

  duplicarPlanejamento(planejamento: Planejamento): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/planejamento/duplicar`,
      planejamento,
    )
  }

  getCulturas(): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/listarCulturas`)
  }

  previstoRealizadoGantt(filtros: any): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/planejamento/previsto-realizado-gantt`,
      filtros,
    )
  }

  getCustoPorHa(planejamentoId: number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/custoPorHa/${planejamentoId}`,
    )
  }

  custo(planejamentoId: number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/CustoPlanejado/${planejamentoId}`,
    )
  }

  areaPlantadaPorSafra(safraId: number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/planejamento/areaPlantadaPorSafra/${safraId}`,
    )
  }
  iniciarPlanejamentos(anoSafraId: number, fazendaId: number, ids: number[]): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/planejamento/iniciarPlanejamentos/${anoSafraId}/${fazendaId}`, ids
    )
  }

  getPlanejamentosPorAnoSafraCulturaFazenda(anoSafraId: number, culturaId: number, fazendaId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/listar/${anoSafraId}/${culturaId}/${fazendaId}`);
  }

  getPlanejamentosPorAnoSafraFazenda(anoSafraId: number, fazendaId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/listar/${anoSafraId}/${fazendaId}`);
  }

  getPlanejamentosPorAnoSafraArea(anoSafraId: number, areaId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/listarPorAnoSafraArea/${anoSafraId}/${areaId}`);
  }

  getPlanejamentosPorAnoSafraAreaCultura(anoSafraId: number, areaId: number, culturaId:number): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/listarPorAnoSafraAreaCultura/${anoSafraId}/${areaId}/${culturaId}`);
  }

  getPlanejamentosPorSafraAreaCultura(safraId: number, areaId: number, culturaId:number): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/listarPorSafraAreaCultura/${safraId}/${areaId}/${culturaId}`);
  }

  listarProjetos(anoSafraId: number, culturaId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/safra/listarprojetos/${anoSafraId}/${culturaId}`);
  }
  listarPulverizacoes(planejamentoId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/planejamento/listarPulverizacoes/${planejamentoId}`);
  }

  salvarPlanejamentos(anoSafraId: number, fazendaId: number, planejamentos: any[]): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/planejamento/SalvarPlanejamentos/${anoSafraId}/${fazendaId}`,
      planejamentos
    );
  }
  salvarPlanejamentosPorTalhao(anoSafraId: number, fazendaId: number, planejamentos: any[]): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/planejamento/SalvarPlanejamentos/${anoSafraId}/${fazendaId}`,
      planejamentos
    );
  }
  buscar(filtro: any): Observable<any> {
    return this.http.post(`${environment.apiURL}/planejamento/buscar`, filtro);
  }
  buscarByStatus(filtro: any): Observable<any> {
    return this.http.post(`${environment.apiURL}/planejamento/buscar/Status`, filtro);
  }
  buscarAreaPlantada(planejamentoIds: number[]): Observable<any> {
    return this.http.post(`${environment.apiURL}/planejamento/areaplantada`, planejamentoIds);
  }

}
